export const handleMarketplaceUrl = () => {
  return 'https://datalab.portexai.com'
}
